import { ApiCompetitionRouteGroup, ApiRoute } from "../types";

export default function getCompetitionRouteDisplay({
  route,
  routeGroupUUID,
  categoryUUIDs,
  categoryUUID,
  routeGroups,
  useFallback = true,
}: {
  route: ApiRoute;
  categoryUUID?: string;
  categoryUUIDs?: string[];
  routeGroupUUID?: string;
  routeGroups: ApiCompetitionRouteGroup[];
  useFallback?: boolean;
}): { name: string; number?: number } {
  const circuitNumber = route.circuitNumber ?? undefined;
  let baseRouteDisplay: { name: string; number?: number };
  if (useFallback) {
    if (route.name) {
      baseRouteDisplay = {
        name: `${circuitNumber ? `${circuitNumber} ` : ""}${route.name}`,
        number: circuitNumber,
      };
    } else {
      baseRouteDisplay = { name: `${circuitNumber}`, number: circuitNumber };
    }
  } else {
    baseRouteDisplay = { name: "" };
  }

  let routeGroup: ApiCompetitionRouteGroup | undefined = undefined;

  if (categoryUUIDs) {
    const displays = categoryUUIDs
      .filter((uuid) => routeGroups.find((x) => x.categories?.includes(uuid)))
      .map((uuid) =>
        getCompetitionRouteDisplay({ route, categoryUUID: uuid, routeGroups }),
      );
    return {
      name: displays.map((x) => x.name).join("/"),
      number: displays[0]?.number,
    };
  }

  if (routeGroupUUID) {
    routeGroup = routeGroups.find((group) => group.uuid === routeGroupUUID);
  } else if (categoryUUID) {
    routeGroup = routeGroups.find((group) =>
      group.categories?.includes(categoryUUID),
    );
  }

  if (routeGroup) {
    // We have a specific route group, so look it up, falling back to the base display if it
    // isn't present
    const display = route.displayRouteGroupMapping?.[routeGroup.uuid];
    if (!display) {
      return baseRouteDisplay;
    }
    return display;
  }

  // We have no specific route group, so display a combined name.

  const names = Object.values(route.displayRouteGroupMapping ?? {}).map(
    (display) => display.name || display.number.toString(),
  );
  if (names.length) {
    return {
      name: names.join("/"),
      number: Object.values(route.displayRouteGroupMapping)[0]?.number,
    };
  } else {
    return baseRouteDisplay;
  }
}
